export const CONFIG = {
    API_URL: process.env.API_URL,
}